export const generateDiscoveryCallHTML = (formData: any, leadDropdownData: any ,allComments: any) => {
    console.log("formData:", formData);

    const formatDate = (date: any) => {
        if (!date) return "";
        const d = new Date(date);
        return isNaN(d.getTime()) ? "" : d.toLocaleDateString("en-GB");
    };

    const formatCurrency = (value: any) => {
        if (!value) return "";
        return `$${parseInt(value).toLocaleString()}`;
    };

    const formatArray = (array: any) => {
        if (!array || !Array.isArray(array) || array.length === 0) return "";
        return array.join(", ");
    };

    const formatComments = (comments: any) => {
        if (!comments || comments.trim() === '') return "";
        return comments.trim();
    };

    // Helper function to get display name from ID
    const getDisplayName = (id: any, options: any[]) => {
        if (!id || !options || !Array.isArray(options)) return "";
        const option = options.find(opt => opt.value === id || opt.value === parseInt(id));
        return option ? option.label : id;
    };

    // Get display names for source and staff
    const sourceDisplayName = getDisplayName(formData.source, leadDropdownData?.leadSources || []);
    const staffDisplayName = getDisplayName(formData.staff, leadDropdownData?.staff || []);

    // Base64-encoded SVG logo for embedding
 
    // PDF HEADER HTML (logo + title)
    const pdfHeaderHTML = `
     <!-- Header -->
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 2px;">
                <div style="flex: 1;">
                    <img src="/assets/images/fintrack_logo.png" style="height: 25px;" alt="Fintrack Logo" />
                </div>
                <div style="flex: 1; text-align:left;">
                    <h3 style="color: #0000ff; margin: 10px; font-weight: bold; font-size: 12px;">Lead Number: ${formData.leadId || "0"}</h3>
                </div>
                <div style="flex: 1; text-align: left;">
                </div>
            </div>
            <hr style="border: 1px solid #0000ff; margin: 1px 0;">
    `;

    // Increase font size for main content
    const mainFontSize = '11px';
    const headerFontSize = '13px';
    const commonWidth = '800px';

    // Section HTML generators (one per form section, matching DiscoveryCall.tsx)
    // Each returns a string of HTML for that section
    // const clientInformationHTML = `
    //     <div style="font-family: Arial, sans-serif; padding: 4px; width: ${commonWidth}; background-color: white; font-size: ${mainFontSize};">
    //         <h4 style="color: #0000ff; margin-bottom: 2px; font-weight: bold; font-size: ${headerFontSize};">CLIENT INFORMATION</h4>
    //         <table style="width: 100%; border-collapse: collapse; font-size: ${mainFontSize};">
    //             <tr>
    //                 <td style="padding: 2px; width: 200px;">Client Name:</td>
    //                 <td style="padding: 2px; border: 1px solid #eee;">${formData.clientName || ""}</td>
    //                 <td style="width: 6px;"></td>
    //                 <td style="padding: 2px; width: 80px;">Source:</td>
    //                 <td style="padding: 2px; border: 1px solid #eee; font-weight: bold;">${sourceDisplayName}</td>
    //             </tr>
    //             <tr>
    //                 <td style="padding: 2px;">Staff:</td>
    //                 <td style="padding: 2px; border: 1px solid #eee;">${staffDisplayName}</td>
    //                 <td></td>
    //                 <td style="padding: 2px;">Date:</td>
    //                 <td style="padding: 2px; border: 1px solid #eee;">${formatDate(formData.discoveryDate)}</td>
    //             </tr>
    //             <tr>
    //                 <td style="padding: 2px;">Mobile:</td>
    //                 <td style="padding: 2px; border: 1px solid #eee;">${formData.mobileNo || ""}</td>
    //                 <td></td>
    //                 <td style="padding: 2px;">Email:</td>
    //                 <td style="padding: 2px; border: 1px solid #eee;">${formData.email || ""}</td>
    //             </tr>
    //         </table>
    //     </div>
    // `;

    // 1. CLIENT DETAILS (Client1/Client2)
    const clientDetailsTableHTML = `
        <div style="font-family: Arial, sans-serif; padding: 4px; width: ${commonWidth}; background-color: white; font-size: ${mainFontSize};">
            <table style="width: 100%; border-collapse: collapse; font-size: ${mainFontSize};">
                <tr>
                    <th style="width: 200px;">            <h4 style="color: #0000ff; margin-bottom: 2px; font-weight: bold; font-size: ${headerFontSize};">CLIENT DETAILS</h4>
</th>
                    <th style="text-align:left; width: 300px;">Client 1</th>
                    <th style="text-align: left; width: 300px;">Client 2</th>
                </tr>
                <tr>
                    <td style="padding: 2px;">Client Name:</td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;">${formData.Client1_Name || formData.clientName || ""}</td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;">${formData.Client2_Name || ""}</td>
                </tr>
                <tr>
                    <td style="padding: 2px;">Current Age:</td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;">${formData.Client1_Age || ""}</td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;">${formData.Client2_Age || ""}</td>
                </tr>
                <tr>
                    <td style="padding: 2px;">Family Situation:</td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;">${formData.Client1_FamilySituation || ""}</td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;">${formData.Client2_FamilySituation || ""}</td>
                </tr>
                <tr>
                    <td style="padding: 2px;">Kids:</td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;">${formData.Client1_Kids || ""}</td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;">${formData.Client2_Kids || ""}</td>
                </tr>
            </table>
        </div>
    `;

    // 2. TAXABLE INCOME SECTION (Home/IP1)
    const taxableIncomeHTML = `
        <div style="font-family: Arial, sans-serif; padding: 4px; width: ${commonWidth}; background-color: white; font-size: ${mainFontSize};">
            <table style="width: 100%; border-collapse: collapse; font-size: ${mainFontSize};">
                <tr>
                    <th style="width: 200px;">   <h4 style="color: #0000ff; margin-bottom: 2px; font-weight: bold; font-size: ${headerFontSize};">TAXABLE INCOME</h4>
                      </th>
                    <th style="text-align: left; width: 300px;"> Client 1</th>
                    <th style="text-align: left; width: 300px;"> Client 2</th>
                </tr>
                <tr>
                    <td style="padding: 2px;">Employment Type:</td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;">${formData.home_EmploymentType || ""}</td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;">${formData.iP1_EmploymentType || ""}</td>
                </tr>
                <tr>
                    <td style="padding: 2px;">Taxable Income:</td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;">${formData.home_TaxableIncome || ""}</td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;">${formData.iP1_TaxableIncome || ""}</td>
                </tr>
            
                <tr>
                    <td style="padding: 2px;">Tax Payable:</td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;">${formData.home_TaxPayable || ""}</td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;">${formData.iP1_TaxPayable || ""}</td>
                </tr>

                 <tr>
                    <td style="padding: 2px;">Tax Bracket:</td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;">${formData.home_TaxBracket || ""}</td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;">${formData.iP1_TaxBracket || ""}</td>
                </tr>
            </table>
        </div>
    `;

    // 3. CURRENT PROPERTY (already present as currentPropertyHTML)
    const currentPropertyHTML = `
        <div style="font-family: Arial, sans-serif; padding: 4px; width: ${commonWidth}; background-color: white; font-size: ${mainFontSize};">
            <table style="width: 100%; border-collapse: collapse; font-size: ${mainFontSize};">
                <tr>
                    <th style="color: #0000ff; text-align: left; padding: 2px; width: 200px; font-size: ${headerFontSize};">PROPERTY</th>
                    <th style="color: #0000ff; text-align: left; padding: 2px;  width: 200px; font-size: ${mainFontSize};">HOME</th>
                    <th style="color: #0000ff; text-align: left; padding: 2px; width: 200px; font-size: ${mainFontSize};">IP1</th>
                    <th style="color: #0000ff; text-align: left; padding: 2px; width: 200px; font-size: ${mainFontSize};">IP2</th>
                </tr>
                <tr>
                    <td style="padding: 2px;">State:</td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;"><span>${formData.Home_State || ""}</span></td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;"><span>${formData.IP1_State || ""}</span></td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;"><span>${formData.IP2_State || ""}</span></td>
                </tr>
                <tr>
                    <td style="padding: 2px;">Suburb:</td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;"><span>${formData.Home_Zoning || ""}</span></td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;"><span>${formData.IP1_Zoning || ""}</span></td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;"><span>${formData.IP2_Zoning || ""}</span></td>
                </tr>
                <tr>
                    <td style="padding: 2px;">Area:</td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;"><span>${formData.Home_Area || ""}</span></td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;"><span>${formData.IP1_Area || ""}</span></td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;"><span>${formData.IP2_Area || ""}</span></td>
                </tr>
                <tr>
                    <td style="padding: 2px;">Postcode:</td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;"><span>${formData.Home_Postcode || ""}</span></td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;"><span>${formData.IP1_Postcode || ""}</span></td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;"><span>${formData.IP2_Postcode|| ""}</span></td>
                </tr>
                <tr>
                    <td style="padding: 2px;">Property Type:</td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;"><span>${formData.Home_PropertyType || ""}</span></td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;"><span>${formData.IP1_PropertyType || ""}</span></td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;"><span>${formData.IP2_PropertyType || ""}</span></td>
                </tr>
          
                <tr>
                    <td style="padding: 2px;">Value:</td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;"><span>${formData.Home_Value || ""}</span></td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;"><span>${formData.IP1_Value || ""}</span></td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;"><span>${formData.IP2_Value || ""}</span></td>
                </tr>
                <tr>
                    <td style="padding: 2px;">Debt:</td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;"><span>${formData.Home_Debt || ""}</span></td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;"><span>${formData.IP1_Debt || ""}</span></td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;"><span>${formData.IP2_Debt || ""}</span></td>
                </tr>
                <tr>
                    <td style="padding: 2px;">Equity:</td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;">
                        <span>${(() => {
                            const value = parseFloat(formData.Home_Value?.replace(/[^0-9.-]/g, '') || '0');
                            const debt = parseFloat(formData.Home_Debt?.replace(/[^0-9.-]/g, '') || '0');
                            const equity = value - debt;
                            return !isNaN(equity) ? (equity < 0 ? `-$ ${Math.abs(equity).toLocaleString()}` : `$ ${equity.toLocaleString()}`) : '';
                        })()}</span>
                    </td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;">
                        <span>${(() => {
                            const value = parseFloat(formData.IP1_Value?.replace(/[^0-9.-]/g, '') || '0');
                            const debt = parseFloat(formData.IP1_Debt?.replace(/[^0-9.-]/g, '') || '0');
                            const equity = value - debt;
                            return !isNaN(equity) ? (equity < 0 ? `-$ ${Math.abs(equity).toLocaleString()}` : `$ ${equity.toLocaleString()}`) : '';
                        })()}</span>
                    </td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;">
                        <span>${(() => {
                            const value = parseFloat(formData.IP2_Value?.replace(/[^0-9.-]/g, '') || '0');
                            const debt = parseFloat(formData.IP2_Debt?.replace(/[^0-9.-]/g, '') || '0');
                            const equity = value - debt;
                            return !isNaN(equity) ? (equity < 0 ? `-$ ${Math.abs(equity).toLocaleString()}` : `$ ${equity.toLocaleString()}`) : '';
                        })()}</span>
                    </td>
                </tr>
                <tr>
                    <td style="padding: 2px;">Rent Weekly:</td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;"><span>${formData.Home_RentWeekly || ""}</span></td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;"><span>${formData.IP1_RentWeekly || ""}</span></td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;"><span>${formData.IP2_RentWeekly || ""}</span></td>
                </tr>
                  <tr>
                    <td style="padding: 2px;">Net Cashflow:</td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;">  <span style="color: ${parseFloat(formData.Home_NetCashflow || '0') < 0 ? 'red' : 'black'};">${formData.Home_NetCashflow || ""}</span></td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;">  <span style="color: ${parseFloat(formData.IP1_NetCashflow || '0') < 0 ? 'red' : 'black'};">${formData.IP1_NetCashflow || ""}</span></td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;">  <span style="color: ${parseFloat(formData.IP2_NetCashflow || '0') < 0 ? 'red' : 'black'};">${formData.IP2_NetCashflow || ""}</span></td>
                </tr>
                  <tr>
                    <td style="padding: 2px;">Gross Yield:</td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;"><span>${formData.Home_GrossYield || ""}</span></td>
                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;">
  <span>
    ${(() => {
      const rent = parseFloat(formData.IP1_RentWeekly?.replace(/[^0-9.-]/g, '') || '0');
      const value = parseFloat(formData.IP1_Value?.replace(/[^0-9.-]/g, '') || '0');
    //   const grossYield = value !== 0 ? Math.floor((rent * 52 ) / value) : 0;
      const grossYield = value !== 0 ? ((rent * 52) / value * 100).toFixed(2) : '0.00';

      return !isNaN(Number(grossYield)) ? `${grossYield}%` : '';
    })()}
  </span>
</td>

                    <td style="padding: 2px; border: 1px solid #eee; text-align: left;"> <span>
    ${(() => {
      const rent = parseFloat(formData.IP2_RentWeekly?.replace(/[^0-9.-]/g, '') || '0');
      const value = parseFloat(formData.IP2_Value?.replace(/[^0-9.-]/g, '') || '0');
    //   const grossYield = value !== 0 ? Math.floor((rent * 52 ) / value) : 0;
      const grossYield = value !== 0 ? ((rent * 52) / value * 100).toFixed(2) : '0.00';
      return !isNaN(Number(grossYield)) ? `${grossYield}%` : '';
    })()}
  </span></td>
                </tr>
            </table>
        </div>
    `;

    // 4. OTHER ASSETS (already present as otherAssetsHTML)
    const otherAssetsHTML = `
        <div style="font-family: Arial, sans-serif; padding: 4px; width: ${commonWidth}; background-color: white; font-size: ${mainFontSize};">
            <h4 style="color: #0000ff; margin-bottom: 2px; font-weight: bold; font-size: ${headerFontSize};">OTHER ASSETS</h4>
            <table style="width: 100%; border-collapse: collapse; font-size: ${mainFontSize};">
                <tr>
                    <td style="padding: 2px; width: 200px;">Savings per month:</td>
                    <td style="padding: 2px; border: 1px solid #eee; width: 195px;"><span>${formData.savingsPerMonth || ""}</span></td>
                     <td style="width: 6px;"></td>
                     <td style="padding: 2px;">Cash in Bank:</td>
                    <td style="padding: 2px; border: 1px solid #eee; width: 195px;"><span>${formData.cashInBank || ""}</span></td>
                </tr>
                
                <tr>
                    <td style="padding: 2px; width: 200px;">Superannuation:</td>
                    <td style="padding: 2px; border: 1px solid #eee; width: 195px;"><span>${formData.superannuation || ""}</span></td>
                     <td style="width: 6px;"></td>
                      <td style="padding: 2px; width: 200px;">SMSF:</td>
                    <td style="padding: 2px; border: 1px solid #eee; width: 195px;"><span>${formData.smsf || ""}</span></td>
                </tr>
            </table>
        </div>
    `;

    // 5. RETIREMENT SECTION
    // Calculate values as in DiscoveryCall.tsx
    const parseNum = (val: any) => {
        if (!val) return 0;
        if (typeof val === 'number') return val;
        return parseFloat(val.toString().replace(/,/g, '').replace(/[^0-9.-]/g, '')) || 0;
    };
    const A = parseNum(formData.taxableIncome);
    const B = parseNum(formData.inflationRate);
     const F = parseNum(formData.yearsToRetire);


      const rateOfreturn = parseNum(formData.iP1)  //Expected rate of return
    // Desired Future Income 
    const desiredFuture = A * Math.pow(1 + rateOfreturn  / 100, F);
    //C: Assets Required 
    const raw = rateOfreturn  !== 0 ? desiredFuture / (rateOfreturn / 100) : 0;
    const C= Math.round(raw / 100) * 100;
    const eq1 = parseNum(formData.Home_Value) - parseNum(formData.Home_Debt);
    const eq2 = parseNum(formData.IP1_Value) - parseNum(formData.IP1_Debt);
    const eq3 = parseNum(formData.IP2_Value) - parseNum(formData.IP2_Debt);
    const eq4 = parseNum(formData.cashInBank);
    const D = eq1 + eq2 + eq3 + eq4;
    const E = C - D;
    const H = parseNum(formData.Client1_Age);
    const G = F + H;
    const fmt = (num: number) => isNaN(num) ? '' : Math.round(num).toLocaleString('en-AU', { maximumFractionDigits: 0 });

    
    

    const retirementHTML = `
        <div style="font-family: Arial, sans-serif; padding: 4px; width: ${commonWidth}; background-color: white; font-size: ${mainFontSize};">
            <h4 style="color: #0000ff; margin-bottom: 2px; font-weight: bold; font-size: ${headerFontSize};">RETIREMENT</h4>
            <table style="width: 100%; border-collapse: collapse; font-size: ${mainFontSize};">
                <tr>
                    <td style="padding: 2px; width: 200px;">Desired Income Today's Value:</td>
                    <td style="padding: 6px 4px; border: 1px solid #eee;">${formData.taxableIncome || ""}</td>
                        <td style="width: 6px;"></td>
                     <td style="padding: 2px; width: 200px;">Inflation Rate:</td>
                    <td style="padding: 6px 4px; border: 1px solid #eee;">${formData.inflationRate || ""}%</td>
                </tr>
               
                   <tr>
                    <td style="padding: 2px; width: 200px;">Years to Retirement:</td>
                    <td style="padding: 6px 4px; border: 1px solid #eee;">${formData.yearsToRetire || ""}</td>
                       
                 
                </tr>
                <tr>
                    <td style="padding: 2px; width: 200px;">Desired Income - Future Value:</td>
                    <td style="padding: 6px 4px; border: 1px solid #eee;">${fmt(desiredFuture)}</td>
                    
                        <td style="width: 6px;"></td>
                     <td style="padding: 2px; width: 200px;">Expected Rate of Return:</td>
                    <td style="padding: 6px 4px; border: 1px solid #eee;">${formData.iP1 || ""}%</td>
                </tr>

                 
                <tr>
                   
                      <td style="padding: 6px 4px; border: 1px solid #eee;vertical-align: middle;">Assets Required:</td>
                    <td style="padding: 6px 4px; border: 1px solid #eee;">${fmt(C)}</td>
                </tr>
             
                <tr>
                    <td style="padding: 2px; width: 200px;">Assets Net after Debt:</td>
                    <td style="padding: 6px 4px; border: 1px solid #eee;">${fmt(D)}</td>
                        <td style="width: 6px;"></td>
                    <td style="padding: 2px; width: 200px;">Asset (Shortfall/Surplus):</td>
                    <td style="padding: 6px 4px; border: 1px solid #eee; font-weight: bold; color: ${E < 0 ? '#28a745' : E > 0 ? '#dc3545' : '#000'};">${fmt(E)}</td>
                </tr>
               
             
                
          
            </table>
        </div>
    `;

    // 6. FINANCE (already present as financeHTML)
    // const financeHTML = `
    //     <div style="font-family: Arial, sans-serif; padding: 4px; width: ${commonWidth}; background-color: white; font-size: ${mainFontSize};">
    //         <h4 style="color: #0000ff; margin-bottom: 2px; font-weight: bold; font-size: ${headerFontSize};">FINANCE</h4>
    //         <table style="width: 100%; border-collapse: collapse; font-size: ${mainFontSize};">
    //             <tr>
    //                 <td style="padding: 2px; width: 200px;">Budget Range:</td>
    //                 <td style="padding: 6px 4px; border: 1px solid #eee; width: 190px;">${(formData.budgetFrom || "")}</td>
    //                     <td style="width: 6px;"></td>
    //                     <td style="padding: 2px; ">Finance Pre-Approved:</td>
    //                 <td style="padding: 6px 4px; border: 1px solid #eee; width: 195px;">${formData.financePreApproved || ""}</td>
    //             </tr>
              
               
    //         </table>
    //     </div>
    // `;

    // 7. STRATEGY FOCUS (already present as strategyFocusHTML)
    const strategyFocusHTML = `
        <div style="font-family: Arial, sans-serif; padding: 4px; width: ${commonWidth}; background-color: white; font-size: ${mainFontSize};">
            <h4 style="color: #0000ff; margin-bottom: 2px; font-weight: bold; font-size: ${headerFontSize};">STRATEGY FOCUS</h4>
            <table style="width: 100%; border-collapse: collapse; font-size: ${mainFontSize};">
              
            
            <tr>
                    <td style="padding: 2px; width: 200px;">Strategy Focus:</td>
                    <td style="padding: 2px; border: 1px solid #eee;">${formData.strategyFocus || ""}</td>
                </tr>
               <tr><td style="padding: 2px; width: 200px;">States Preferred:</td><td style="padding: 2px; border: 1px solid #eee;">${formatArray(formData.statesPreferred)}</td></tr>
            </table>
        </div>
    `;

   

    // 9. COMMENTS (already present as commentsHTML)
    // const commentsHTML = `
    //     <div style="font-family: Arial, sans-serif; padding: 4px; width: ${commonWidth}; background-color: white; font-size: ${mainFontSize};">
    //         <h4 style="color: #0000ff; margin-bottom: 2px; font-weight: bold; font-size: ${headerFontSize};">COMMENTS AND NON NEGOTIABLES</h4>
    //         <div style="border: 1px solid #eee; padding: 2px; min-height: 20px; background-color: #fafafa;">
    //             <p style="margin: 0; white-space: pre-wrap;  font-size: ${mainFontSize};">${formatComments(formData.comments)}</p>
    //         </div>
    //     </div>
    // `;
    const commentsHTML = `
     <!-- Property Section End -->

                <div style="font-family: Arial, sans-serif; padding: 4px; width: ${commonWidth}; background-color: white; font-size: ${mainFontSize};">

         <h3 style="color: blue; font-weight: bold; margin-bottom: 10px; font-size: ${mainFontSize};"> Lead Comments</h3>
            <table style="width: 100%; border-collapse: collapse; font-size: ${mainFontSize};">
                ${allComments.map((comment: any) => {
                    const formattedDate = new Date(comment.createdOn).toLocaleString("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric"
                    });
                    
                    const matchedStaff = leadDropdownData?.staff?.find((s: any) => s.value == comment.staff);
                    const staffName = matchedStaff ? matchedStaff.label : "N/A";

                    return `
                        <tr>
                            <td style="padding: 8px; color: blue;">
                                <strong>Date: ${formattedDate} &nbsp;&nbsp;&nbsp; Staff Name: ${staffName}</strong>
                            </td>
                        </tr>
                        <tr>
                            <td style="padding: 8px 8px 15px 8px; border-bottom: 2px solid #ddd;">
                                ${comment.commentText}
                            </td>
                        </tr>
                    `;
                }).join("") || "<tr><td>No comments available.</td></tr>"}
            </table>

            </div>
    `;

    // Compose sections into pages with header
    const page1HTML = pdfHeaderHTML  + clientDetailsTableHTML + taxableIncomeHTML + currentPropertyHTML  + otherAssetsHTML  + retirementHTML  + strategyFocusHTML ;
    const page2HTML = pdfHeaderHTML + commentsHTML
    return { page1HTML, page2HTML };
};